export const CategoriesTwo = () => {
  return (
    <section className="Section 3">
        <div className="categories-two">
            <div className="categories-two__content">
                <div className='box' id="c3-1">
                    <div className="box__content">
                        <div className="bg-black"></div>
                        <div className="btn-white">
                            <a href="https://www.lippioutdoor.com/kids.html" target='_parent'>Niños y Niñas</a>
                        </div>
                    </div>
                </div>
                <div className='box' id="c3-2">
                    <div className="box__content">
                        <div className="bg-black"></div>
                        <div className="btn-white">
                            <a href="https://www.lippioutdoor.com/calzado.html" target='_parent'>Calzado</a>
                        </div>
                    </div>
                </div>
                <div className='box' id="c3-3">
                    <div className="box__content">
                        <div className="bg-black"></div>
                        <div className="btn-white">
                            <a href="https://www.lippioutdoor.com/accesorios-y-equipamiento.html" target='_parent'>Accesorios y equipamiento</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default CategoriesTwo